<template>
  <yxt-card
    class="gwnl-card basic-box-card"
    shadow="never"
  >
    <div
      slot="header"
      class="clearfix standard-size-16 font-medium align-items-center"
    >
      <yxt-svg
        :remote-url="gwnlMediaDomain + 'svg/'"
        width="28px"
        height="28px"
        icon-class="gwnl_pc_jq_detail_basic_info"
        class="mr12"
      />
      <span>{{ $t('pc_gwnl_model_template__info_basic_title') }}</span>
    </div>
    <div
      class="flex justify-content-between flex-wrap is-preview"
    >
      <div class="flex row-item pb16">
        <div class="color-gray-7 mr24">
          {{ $t('gwnl_gwnl_pc_model_level') }}：
        </div>
        <div>
          {{ previewBasic.enableSkillLevel ? $t('pc_gwnl_level_model') : `${$t('pc_gwnl_global_tag_noLevel')}${$t('pc_gwnl_eval_model')}` }}
        </div>
      </div>
      <div class="flex row-item pb16">
        <div class="color-gray-7 mr24">
          {{ $t('gwnl_gwnl_pc_model_attribute') }}：
        </div>
        <div>
          {{ previewBasic.attribute || '--' }}
        </div>
      </div>
      <div class="flex row-item pb16">
        <div class="color-gray-7 mr24">
          {{ $t('gwnl_gwnl_pc_model_hierarchical') }}：
        </div>
        <div>
          {{ previewBasic.hierarchical || '--' }}
        </div>
      </div>
    </div>
    <div class="gwnl-jq-preview__basic">
      <div
        class="gwnl-jq-preview__basic-row"
      >
        <div class="gwnl-jq-preview__basic-row-box">
          <div class=" color-gray-7 mr24 ">
            {{ $t('pc_gwnl_model_template__table_column_description') }}：
          </div>
          <div
            v-if="previewBasic.modelDesc"
            class="gwnl-jq-preview__basic-row-box-info gwnl-pre-wrap"
            v-text="previewBasic.modelDesc"
          />
          <div
            v-else
            class="color-gray-6"
          >
            --
          </div>
        </div>
      </div>
    </div>
  </yxt-card>
</template>

<script>
import { MODEL_TYPE } from './enum';
import { GWNL_MEDIA_DOMAIN } from './domain';

export default {
  props: {
    previewBasic: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      MODEL_TYPE: MODEL_TYPE,
      gwnlMediaDomain: GWNL_MEDIA_DOMAIN
    };
  }
};
</script>
<style lang="scss" scoped>
.gwnl-jq-preview__basic {
  .gwnl-jq-preview__basic-row {
    display: flex;
    flex-direction: column;
  }

  .gwnl-jq-preview__basic-row-box {
    display: flex;
    flex-direction: row;
    overflow: hidden;
  }

  .gwnl-jq-preview__basic-row-box-info {
    flex: 1 1 auto;
    width: calc(100% - 118px);
    margin-right: 24px;
  }
}

.height24 {
  height: 24px;
}

.width70 {
  width: 70px;
}

.row-item {
  width: 50%;
}

.is-preview {
  .row-item {
    width: 33.33%;
  }
}
</style>
